import { APPLICATION_ROUTES } from 'constants/routes';
import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link } from '@mui/material';

// project imports
import Logo from 'shared/components/ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <Link component={RouterLink} to={APPLICATION_ROUTES.consolidatedReport} aria-label="theme-logo">
        <Logo />
    </Link>
);

export default LogoSection;
